// extracted by mini-css-extract-plugin
export default {"textOnBackgroundImage":"textOnBackgroundImage___2FQYK","figure":"figure___1tbvC","isInverted":"isInverted___28ioH","text":"text___cPAij"};